import { createFileRoute } from '@tanstack/react-router'
import { ReceiveScreen } from '../features/procurement'

// The phone receive screen (procurement.md §4): no loader, so an unreachable order renders its own state.
export const Route = createFileRoute('/receive/$orderId')({
  component: function ReceiveRoute() {
    const { orderId } = Route.useParams()
    return <ReceiveScreen key={orderId} orderId={orderId} />
  },
})
